import { EnergySavingIcon } from '~/icons';
import { useTranslation } from 'react-i18next';
import { ModalTemplate } from '../ModalTemplate';

interface EconomyMode {
  isOpen: boolean;
  onClose: () => void;
}

export const ModalEconomyModeInfo: React.FC<EconomyMode> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <ModalTemplate
      isOpen={isOpen}
      onClose={onClose}
      text={t('modoEconomiaInfo')}
      title={t('modoEconomia')}
      iconTitle={<EnergySavingIcon />}
      button1={t('fechar')}
      button1Action={onClose}
      centralizedText
      dataTestId="economy-modal-info"
    />
  );
};
